document.addEventListener('DOMContentLoaded', function () {
  const emailInput = document.querySelector('input[type="email"]');
  const rememberCheckbox = document.querySelector('#login');

  if (localStorage.getItem('rememberEmail') && emailInput) {
    emailInput.value = localStorage.getItem('rememberEmail');
    rememberCheckbox.checked = true;
  }

  if (rememberCheckbox) {
    rememberCheckbox.addEventListener('change', function () {
      if (this.checked && emailInput.value) {
        localStorage.setItem('rememberEmail', emailInput.value);
      } else {
        localStorage.removeItem('rememberEmail');
      }
    });
  }

  const loginForm = document.querySelector('.login-form');
  if (loginForm) {
    loginForm.addEventListener('submit', function (event) {
      event.preventDefault();

      if (rememberCheckbox.checked && emailInput.value) {
        localStorage.setItem('rememberEmail', emailInput.value);
      } else {
        localStorage.removeItem('rememberEmail');
      }

      setTimeout(() => {
        this.submit();
      }, 100);
    });
  }
});
